import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { LOGIN_ROUTE } from 'src/constants/routes';
import { selectAuth } from 'src/store/user/selectors';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isLoggedIn } = useSelector(selectAuth);
  const location = useLocation();
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isLoggedIn) {
    if (!isMounted) return null;

    return <Navigate to={LOGIN_ROUTE} state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
